// Generado desde design-system/brand/DbIcons.tsx — no editar; edita el .ts/.tsx y corre build-ds.
function make(name, children) {
    function Icon({ size = 24, strokeWidth = 2, className, style, fill = 'none', 'aria-hidden': ariaHidden = 'true' }) {
        return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} style={style} aria-hidden={ariaHidden} data-db-icon={name}>
        {children}
      </svg>);
    }
    Icon.displayName = name;
    return Icon;
}
/** IA: corchetes desfasados con un rombo al centro. */
export const DbAi = make('DbAi', <>
    <path d="M9.6 6.38 3.4 10.54Q2.58 11.24 2.58 12.12 2.58 12.94 3.22 13.7L9.31 20.66"/>
    <path d="M14.17 3.45 21.31 11.24Q21.95 12.12 21.19 13L14.52 18.38"/>
    <path d="M12 10.01 14.17 12.18 12 14.34 9.83 12.18Z" fill="currentColor"/>
  </>);
/** Agente: contenedor abierto con un nodo que traza una ruta hasta la acción. */
export const DbAgent = make('DbAgent', <>
    <path d="M3.69 7.9 10.3 3.69Q11.59 2.93 12.88 3.69L17.44 6.56"/>
    <path d="M12.47 20.78 17.44 17.85"/>
    <path d="M18.5 9.25 21.42 12 18.5 14.75"/>
    <path d="M4.57 14.52 9.25 17.8Q10.3 18.5 11.12 17.44 11.71 16.51 11.77 15.22L12 12H21.19"/>
    <circle cx="4.1" cy="14.17" r="1.35" fill="currentColor"/>
  </>);
